module.exports = __webpack_public_path__ + "static/media/logocopy.03b25177.png";